import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/learn',
    name: 'Learn',
    component: () => import(/* webpackChunkName: "learn" */ '../views/Learn.vue'),
    children: [
      {
        path: ':id',
        name: 'Some topic',
        component: () => import(/* webpackChunkName: "learn" */ '../components/learn/TopicContent'),
        props: true
      }
    ]
  },
  {
    path: '/speech_constructor',
    name: 'Speech Constructor',
    component: () => import(/* webpackChunkName: "speech" */ '../views/SpeechConstructor')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login')
  },
  {
    path: '/tribune',
    name: 'Tribune',
    component: () => import(/* webpackChunkName: "tribune" */ '../views/Tribune')
  },
  {
    path: '/tribune/:tribuneName',
    name: 'TribuneRoom',
    component: () => import(/* webpackChunkName: "tribune" */ '../views/TribuneRoom'),
    props: true
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
